import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Menu,
  MenuItem,
  Box,
  Button,
  Chip,
  Avatar,
} from '@mui/material';
import {
  Menu as MenuIcon,
  NotificationsOutlined,
  AccountCircleOutlined,
  LogoutOutlined,
  PersonOutlined,
  SettingsOutlined,
  SecurityOutlined,
} from '@mui/icons-material';

interface NavbarProps {
  onSidebarToggle: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onSidebarToggle }) => {
  const user = { username: 'Admin User' };
  const logout = () => console.log('Logout clicked');
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleProfileMenuClose();
  };

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar sx={{ px: 2 }}>
        <IconButton
          color="inherit"
          aria-label="toggle sidebar"
          onClick={onSidebarToggle}
          edge="start"
          sx={{ 
            mr: 2,
            '&:hover': {
              backgroundColor: 'rgba(37, 99, 235, 0.08)',
            }
          }}
        >
          <MenuIcon />
        </IconButton>

        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              fontWeight: 700,
              background: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.025em',
            }}
          >
            Counterfeit Detection Platform
          </Typography>
          
          <Chip 
            label="AI-Powered" 
            size="small" 
            sx={{ 
              backgroundColor: 'rgba(37, 99, 235, 0.1)',
              color: '#2563eb',
              fontWeight: 600,
              fontSize: '0.75rem',
            }}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Notifications */}
          <IconButton 
            color="inherit"
            sx={{ 
              '&:hover': {
                backgroundColor: 'rgba(37, 99, 235, 0.08)',
              }
            }}
          >
            <Badge badgeContent={4} color="error">
              <NotificationsOutlined />
            </Badge>
          </IconButton>

          {/* User Profile */}
          <Button
            color="inherit"
            onClick={handleProfileMenuOpen}
            startIcon={
              <Avatar 
                sx={{ 
                  width: 28, 
                  height: 28, 
                  backgroundColor: 'rgba(37, 99, 235, 0.1)',
                  color: '#2563eb',
                  fontSize: '0.875rem',
                  fontWeight: 600,
                }}
              >
                {user?.username?.charAt(0).toUpperCase() || 'U'}
              </Avatar>
            }
            sx={{ 
              textTransform: 'none',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'rgba(37, 99, 235, 0.08)',
              }
            }}
          >
            {user?.username || 'User'}
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleProfileMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 200,
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1), 0 4px 10px rgba(0, 0, 0, 0.06)',
                border: '1px solid #e2e8f0',
                borderRadius: 2,
              }
            }}
          >
            <MenuItem 
              onClick={handleProfileMenuClose}
              sx={{ 
                py: 1.5,
                '&:hover': {
                  backgroundColor: 'rgba(37, 99, 235, 0.08)',
                }
              }}
            >
              <PersonOutlined sx={{ mr: 2, color: '#64748b' }} />
              Profile
            </MenuItem>
            <MenuItem 
              onClick={handleProfileMenuClose}
              sx={{ 
                py: 1.5,
                '&:hover': {
                  backgroundColor: 'rgba(37, 99, 235, 0.08)',
                }
              }}
            >
              <SettingsOutlined sx={{ mr: 2, color: '#64748b' }} />
              Settings
            </MenuItem>
            <MenuItem 
              onClick={handleProfileMenuClose}
              sx={{ 
                py: 1.5,
                '&:hover': {
                  backgroundColor: 'rgba(37, 99, 235, 0.08)',
                }
              }}
            >
              <SecurityOutlined sx={{ mr: 2, color: '#64748b' }} />
              Security
            </MenuItem>
            <MenuItem 
              onClick={handleLogout}
              sx={{ 
                py: 1.5,
                color: '#ef4444',
                '&:hover': {
                  backgroundColor: 'rgba(239, 68, 68, 0.08)',
                }
              }}
            >
              <LogoutOutlined sx={{ mr: 2 }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 